import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const SidePanelContext = createContext();

// Breakpoint matching Tailwind's `lg:` (1024px)
const MOBILE_BREAKPOINT = 1024;

const getInitialState = () => {
  if (typeof window === 'undefined') return true;
  return window.innerWidth >= MOBILE_BREAKPOINT;
};

export const useSidePanel = () => {
  const context = useContext(SidePanelContext);
  if (!context) {
    throw new Error('useSidePanel must be used within a SidePanelProvider');
  }
  return context;
};

export const SidePanelProvider = ({ children }) => {
  const [showSidePanel, setShowSidePanel] = useState(getInitialState);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < MOBILE_BREAKPOINT : false
  );

  // Listen for resize to track mobile state and auto-close sidebar when shrinking
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      // Auto-close sidebar when resizing down to mobile
      if (mobile) {
        setShowSidePanel(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidePanel = useCallback(() => {
    setShowSidePanel(prev => !prev);
  }, []);

  return (
    <SidePanelContext.Provider value={{ showSidePanel, setShowSidePanel, toggleSidePanel, isMobile }}>
      {children}
    </SidePanelContext.Provider>
  );
};
